Coloris({
    theme: 'pill',
    // themeMode: 'light',
    defaultColor: '',
});